// import React from "react";


// function AdvancedCardiacCare() {
//   return (
//     <div>
//       <PosterOne img={aboutbanner} title={"Advanced Cardiac Care & Disease Management"} />
//       <h1>AdvancedCardiacCare</h1>
//       <h2>AdvancedCardiacCare</h2>
//       <h3>AdvancedCardiacCare</h3>
//     </div>
//   );
// }

// export default AdvancedCardiacCare;

import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";
import BannerOne from "../share/component.jsx/banner";

/* ─── ANIMATED COUNTER ───────────────────────────────── */
const Counter = ({ value }) => {
  const [d, setD] = useState("0");
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        const num = parseFloat(value.replace(/[^0-9.]/g, ""));
        const suf = value.replace(/[0-9.]/g, "");
        let s = 0; const step = num / 50;
        const t = setInterval(() => {
          s += step;
          if (s >= num) { setD(value); clearInterval(t); }
          else setD((Number.isInteger(step) ? Math.floor(s) : Math.floor(s)) + suf);
        }, 25);
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref}>{d}</span>;
};

/* ─── CIRCULAR VITALS WIDGET ─────────────────────────── */
const VitalsWidget = () => {
  const [bpm, setBpm] = useState(72);
  const [tick, setTick] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setBpm(prev => {
        const delta = Math.floor(Math.random() * 5) - 2;
        return Math.min(85, Math.max(58, prev + delta));
      });
      setTick(t => !t);
    }, 1400);
    return () => clearInterval(interval);
  }, []);

  const r = 54, cx = 70, cy = 70;
  const circumference = 2 * Math.PI * r;
  const progress = ((bpm - 40) / 80) * circumference;

  return (
    <div style={{ position: "relative", width: 140, height: 140 }}>
      <svg width={140} height={140} viewBox="0 0 140 140">
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={10} />
        <circle
          cx={cx} cy={cy} r={r} fill="none"
          stroke="url(#vg)" strokeWidth={10}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          transform={`rotate(-90 ${cx} ${cy})`}
          style={{ transition: "stroke-dashoffset 1.2s ease" }}
        />
        <defs>
          <linearGradient id="vg" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#2acb35" />
            <stop offset="100%" stopColor="#6edc8d" />
          </linearGradient>
        </defs>
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 32, fontWeight: 900, color: "#fff", lineHeight: 1, letterSpacing: "-0.03em" }}>{bpm}</span>
        <span style={{ fontSize: 10, color: "rgba(255,255,255,0.45)", letterSpacing: "0.14em", fontFamily: "'Hind', sans-serif", textTransform: "uppercase", marginTop: 2 }}>BPM</span>
        <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2acb35", marginTop: 4, animation: tick ? "vitalblink 0.15s ease" : "none" }} />
      </div>
    </div>
  );
};

/* ─── CARE PLAN VISUAL ───────────────────────────────── */
const CarePlanCircle = () => {
  const slices = [
    { label: "Medication", color: "#2acb35", deg: 0, size: 90 },
    { label: "Lifestyle", color: "#6edc8d", deg: 90, size: 80 },
    { label: "Monitoring", color: "#1A7A52", deg: 170, size: 100 },
    { label: "Prevention", color: "#86e3aa", deg: 260, size: 70 },
  ];
  return (
    <div style={{ position: "relative", width: 240, height: 240, margin: "0 auto" }}>
      {/* center */}
      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg,#1a3a2a,#0d2018)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }}>
        <span style={{ fontSize: 28 }}>🫀</span>
      </div>
      {slices.map((s, i) => (
        <div key={s.label} style={{ position: "absolute", top: "50%", left: "50%", width: s.size, height: s.size, borderRadius: "50%", background: s.color, transform: `rotate(${s.deg}deg) translate(60px) translateY(-50%)`, opacity: 0.85, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 4px 16px ${s.color}66`, animation: `orbit${i} 12s linear infinite`, zIndex: 2 }}>
          <span style={{ fontSize: 10, fontWeight: 700, color: "#fff", transform: `rotate(-${s.deg}deg)`, fontFamily: "'Hind', sans-serif", letterSpacing: "0.06em", textTransform: "uppercase" }}>{s.label}</span>
        </div>
      ))}
    </div>
  );
};

/* ─── DATA ───────────────────────────────────────────── */
const CONDITIONS = [
  { image: require("../assets/services/Heart_Failure.jpg"), title: "Heart Failure", sub: "Advanced HF Management", desc: "We offer full management of HFrEF, HFpEF, and HFmrEF with a view to enhancing symptoms, decreasing hospitalizations, and sustaining long-term stability. We take care of GDMT optimization, diuretic titration, monitoring of fluids, CRT, and ICD candidacy review, LVAD consideration, and practical guidance on daily heart health.", color: "#86e3aa" },
  { image: require("../assets/services/Coronary_Artery_Disease.jpg"), title: "Coronary Artery Disease", sub: "Long-Term CAD Care", desc: "Our cardiology care unit takes care of patients once they have been stented, had bypass surgery, or have received a new diagnosis. We discuss antiplatelet therapy, cholesterol goals, blood pressure management, and lifestyle measures that assist in maintaining plaque and minimize cardiac risk in the future.", color: "#2acb35" },
  { image: require('../assets/services/Arrhythmia_Management.jpg'), title: "Arrhythmia Management", sub: "Rate & Rhythm Strategy", desc: "We have organized long-term planning to manage atrial fibrillation, atrial flutter, SVT, ventricular arrhythmias, and other rhythm issues. Our strategy includes anticoagulation, rate and rhythm control, symptom monitoring, medication optimization, and ablation candidacy consideration.", color: "#6edc8d" },
  { image: require('../assets/services/Hypertension_Control.jpg'), title: "Hypertension Control", sub: "BP Management & Protection", desc: "We assist patients with uncontrolled or resistant hypertension by evaluating them in detail and providing follow-up assistance. Care comprises ambulatory blood pressure monitoring review, optimization of medication regimen, lifestyle guidance, and kidney/heart protection planning to reduce long-term cardiovascular risk.", color: "#1A8F5F" },
  { image: require('../assets/services/Cardiomyopathy.jpg'), title: "Cardiomyopathy", sub: "Genetic & Risk-Based Care", desc: "Our care of cardiomyopathy encompasses hypertrophic, dilated, restrictive, and infiltrative heart muscle diseases. We develop personalized plans depending on imaging, symptoms, family history, and level of risk, involving medication management, genetic counseling, family screening, and long-term monitoring.", color: "#86e3aa" },
  { image: require('../assets/services/Valvular Heart Disease.jpg'), title: "Valvular Heart Disease", sub: "Surveillance & Timing", desc: "Our longitudinal follow-up of aortic stenosis, mitral regurgitation, tricuspid disease, and other valve conditions is available. We evaluate symptoms, echocardiography results, disease severity, and timing of intervention to assist patients in knowing when surveillance, repair, replacement, or specialist referral is necessary.", color: "#2acb35" },
];

const PILLARS = [
  { num: "01", icon: "💊", title: "Medication Review & Optimization", desc: "We will examine your entire cardiac medication list to determine interactions, duplicated therapy, side effects, missed treatment opportunities, and dose issues. Your plan is modified based on your condition, prevailing guidelines, and personal tolerance. This assists in enhancing the value of treatment and minimizing unnecessary risks." },
  { num: "02", icon: "🥗", title: "Lifestyle & Nutrition Strategy", desc: "We design customized lifestyle plans that suit your health requirements and day-to-day activities. This can involve heart-healthy meal planning, safe exercise prescriptions, weight management, smoking cessation counseling, alcohol reduction, and stress management, all intended to improve heart functioning." },
  { num: "03", icon: "🛡️", title: "Cardiovascular Prevention", desc: "Our prevention plan is aimed at decreasing the number of cardiac events in the future. We check cholesterol, blood pressure, glucose, inflammation, family history, and lifestyle risks. Your intervention plan can incorporate statin therapy follow-ups, aspirin follow-ups, advanced lipid treatment follow-ups, and periodic progress reviews." },
  { num: "04", icon: "📡", title: "Remote Monitoring & Check-ins", desc: "We follow up with patients between visits via structured virtual follow-up, blood pressure check, weight monitoring, symptoms, and device report assessment as needed. This assists in identifying changes earlier and providing quicker access to guidance when symptoms or concerns change." },
];

const STATS = [
  { val: "30K+", lbl: "Patients Managed" },
  { val: "92%", lbl: "Readmission Reduction" },
  { val: "25+", lbl: "Years Experience" },
  { val: "4.9★", lbl: "Patient Rating" },
];

const TESTIMONIALS = [
  { quote: "Three weeks later, I got back my energy, and I finally realized how my treatment plan was working against me.", name: "Robert M.", age: "67", condition: "Heart Failure" },
  { quote: "I was on four different types of blood pressure medicines, but my numbers continued to be high after eight months of use. My care team simplified my plan, explained all the changes, and after eight months of using my numbers, they have remained controlled.", name: "Priya S.", age: "54", condition: "Hypertension" },
  { quote: "Since I had a stent, I am much more confident and in control now because of the care plan.", name: "James T.", age: "61", condition: "Coronary Artery Disease" },
];

const HOW_STEPS = [
  { num: "01", title: "Share Your History", desc: "Upload medical records, current medications, recent investigations, and describe your symptoms through our secure patient portal." },
  { num: "02", title: "Expert Assessment", desc: "A dedicated cardiologist reviews your complete cardiac history and designs a personalized cardiac patient management plan." },
  { num: "03", title: "Receive Your Care Plan", desc: "A detailed written cardiovascular care plan covering medications, lifestyle, monitoring schedule, and prevention strategy — within 72 hours." },
  { num: "04", title: "Ongoing Support", desc: "Regular virtual check-ins, medication adjustments, remote monitoring reviews, and 24/7 clinical messaging access." },
];

/* ─── CONDITION CARD ─────────────────────────────────── */
const ConditionCard = ({ c, i }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: "#fff",
        border: `1.5px solid ${hov ? c.color + "66" : "#e8f0eb"}`,
        borderRadius: 20,
        padding: "30px 26px",
        transition: "all 0.35s cubic-bezier(.22,.68,0,1.15)",
        transform: hov ? "translateY(-7px)" : "translateY(0)",
        boxShadow: hov ? `0 20px 52px ${c.color}22` : "0 2px 16px rgba(0,0,0,0.05)",
        cursor: "default", display: "flex", flexDirection: "column",
        animationDelay: `${i * 0.1}s`,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
        <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s" }}>
          {c.image ? (
            <img src={c.image} alt={c.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{c.icon}</span>
          )}
        </div>
        <div style={{ width: 8, height: 8, borderRadius: "50%", background: c.color, marginTop: 8, boxShadow: hov ? `0 0 0 4px ${c.color}22` : "none", transition: "box-shadow 0.3s" }} />
      </div>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: c.color, marginBottom: 6, fontFamily: "'Hind', sans-serif" }}>{c.sub}</div>
      <h3 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 20, fontWeight: 700, color: "#132a1e", margin: "0 0 12px", lineHeight: 1.25, letterSpacing: "-0.02em" }}>{c.title}</h3>
      <p style={{ fontSize: 13.5, color: "#5a7a65", lineHeight: 1.78, fontFamily: "'Lora', serif", margin: 0, flexGrow: 1 }}>{c.desc}</p>
    </div>
  );
};

/* ─── PILLAR CARD ────────────────────────────────────── */
const PillarCard = ({ p, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      display: "flex", gap: 20, padding: "22px 24px",
      borderRadius: 16, cursor: "pointer",
      background: active ? "rgba(42,203,53,0.12)" : "transparent",
      border: `1.5px solid ${active ? "#2acb35" : "transparent"}`,
      transition: "all 0.28s ease",
    }}
  >
    <div style={{ width: 48, height: 48, borderRadius: 12, background: active ? "#2acb35" : "rgba(42,203,53,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, transition: "background 0.3s" }}>{p.icon}</div>
    <div>
      <div style={{ fontSize: 10, fontFamily: "'Hind', sans-serif", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: active ? "#2acb35" : "#8aab92", marginBottom: 4 }}>{p.num}</div>
      <h4 style={{ fontFamily: "'Fraunces', serif", fontSize: 17, fontWeight: 700, color: active ? "#fff" : "rgba(255,255,255,0.65)", margin: "0 0 6px", letterSpacing: "-0.01em", lineHeight: 1.3 }}>{p.title}</h4>
      {active && <p style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", lineHeight: 1.75, fontFamily: "'Lora', serif", margin: 0 }}>{p.desc}</p>}
    </div>
  </div>
);

/* ─── TESTIMONIAL ────────────────────────────────────── */
const Testimonial = ({ t, active }) => (
  <div style={{
    background: "#fff", border: "1.5px solid #e0ede6",
    borderRadius: 20, padding: "32px 28px",
    opacity: active ? 1 : 0.45,
    transform: active ? "scale(1)" : "scale(0.96)",
    transition: "all 0.4s ease",
    boxShadow: active ? "0 12px 40px rgba(45,155,107,0.12)" : "none",
  }}>
    <div style={{ fontSize: 36, color: "#2acb35", fontFamily: "'Fraunces', serif", lineHeight: 1, marginBottom: 16, opacity: 0.4 }}>"</div>
    <p style={{ fontSize: 15.5, color: "#2a4a34", lineHeight: 1.8, fontFamily: "'Lora', serif", fontStyle: "italic", margin: "0 0 22px" }}>{t.quote}</p>
    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: "50%", background: "linear-gradient(135deg,#2acb35,#6edc8d)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 700, color: "#fff", fontFamily: "'Fraunces', serif" }}>{t.name[0]}</div>
      <div>
        <div style={{ fontFamily: "'Fraunces', serif", fontWeight: 700, fontSize: 15, color: "#132a1e" }}>{t.name}, {t.age}</div>
        <div style={{ fontSize: 11, color: "#2acb35", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", fontFamily: "'Hind', sans-serif" }}>{t.condition}</div>
      </div>
    </div>
  </div>
);

/* ─── MAIN ───────────────────────────────────────────── */
export default function AdvancedCardiacCare() {
  const navigate = useNavigate();
  const [activePillar, setActivePillar] = useState(0);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const t1 = setInterval(() => setActivePillar(p => (p + 1) % PILLARS.length), 3200);
    const t2 = setInterval(() => setActiveTestimonial(p => (p + 1) % TESTIMONIALS.length), 4500);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, []);

  return (
    <>
      <Helmet>
        <title>Heart &amp; Cardiac Care | Expert Cardiatric Doctor</title>
        <meta
          name="description"
          content="Comprehensive cardiovascular care with trusted cardiatric doctors. Heart care for you with advanced treatments and personalized cardiac support."
        />
      </Helmet>

      <style>{`
       

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --forest: #0f2918;
          --deep: #112e1c;
          --green: #2acb35;
          --mid: #66d48a;
          --light: #86e3aa;
          --sage: #eaf8ee;
          --cream: #ffffff;
          --muted: #4f6f58;
          --gold: #bfd3a5;
        }

        @keyframes vitalblink { 0%,100%{opacity:1;transform:scale(1.5)} 50%{opacity:0.3;transform:scale(0.8)} }
        @keyframes floatup { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
        @keyframes gentle-rotate { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        @keyframes fadeup { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }

        /* Root font and heading rules moved to shared CSS (service-screen.css) */

        /* NAV */
        .acc-nav {
          position: sticky; top: 0; z-index: 100;
          background: rgba(13,32,24,0.97);
          backdrop-filter: blur(20px);
          padding: 0 56px;
          display: flex; align-items: center; justify-content: space-between;
          height: 70px;
          border-bottom: 1px solid rgba(42,203,53,0.12);
        }
        .acc-logo { display: flex; align-items: center; gap: 12px; text-decoration: none; }
        .acc-logo-mark {
          width: 40px; height: 40px; border-radius: 10px;
          background: linear-gradient(135deg, var(--green), var(--mid));
          display: flex; align-items: center; justify-content: center;
          font-size: 20px;
        }
        .acc-logo-name { font-family: 'Fraunces', serif; font-size: 18px; font-weight: 700; color: #fff; letter-spacing: -0.02em; line-height: 1.2; }
        .acc-logo-sub { display: block; font-size: 9px; color: rgba(255,255,255,0.35); letter-spacing: 0.16em; text-transform: uppercase; font-family: 'Hind', sans-serif; font-weight: 400; }
        .acc-nav-links { display: flex; gap: 28px; list-style: none; }
        .acc-nav-links a { text-decoration: none; font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.5); transition: color 0.2s; }
        .acc-nav-links a:hover { color: var(--green); }
        .acc-nav-right { display: flex; gap: 10px; align-items: center; }
        .acc-btn-ghost { background: rgba(42,203,53,0.1); color: rgba(255,255,255,0.75); border: 1px solid rgba(42,203,53,0.2); padding: 9px 20px; border-radius: 30px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: 'Hind', sans-serif; transition: all 0.2s; }
        .acc-btn-ghost:hover { background: rgba(42,203,53,0.2); color: var(--green); }
        .acc-btn-cta { background: linear-gradient(135deg, var(--green), var(--mid)); color: #fff; border: none; padding: 10px 22px; border-radius: 30px; font-size: 13px; font-weight: 700; cursor: pointer; font-family: 'Hind', sans-serif; transition: all 0.2s; box-shadow: 0 4px 16px rgba(42,203,53,0.35); }
        .acc-btn-cta:hover { opacity: 0.9; transform: translateY(-1px); }
        .acc-hamburger { display: none; background: none; border: none; color: #fff; font-size: 22px; cursor: pointer; }

        /* HERO */
        .acc-hero {
          background: var(--forest);
          position: relative; overflow: hidden;
          min-height: 95vh;
          display: grid;
          grid-template-columns: 52% 48%;
        }
        .acc-hero-left { padding: 110px 56px 80px; display: flex; flex-direction: column; justify-content: center; position: relative; z-index: 2; }
        .acc-hero-right { position: relative; z-index: 2; padding: 60px 52px 60px 40px; display: flex; flex-direction: column; justify-content: center; gap: 20px; }

        .acc-hero::before {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 50% 70% at 100% 30%, rgba(42,203,53,0.15) 0%, transparent 65%),
            radial-gradient(ellipse 30% 50% at 10% 90%, rgba(45,155,107,0.1) 0%, transparent 55%),
            radial-gradient(ellipse 60% 40% at 50% 110%, rgba(13,32,24,0) 0%, rgba(42,203,53,0.06) 100%);
          pointer-events: none; z-index: 1;
        }

        /* organic blob bg */
        .acc-blob {
          position: absolute; border-radius: 50%;
          filter: blur(60px); pointer-events: none; z-index: 0;
        }

        .acc-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(42,203,53,0.12);
          border: 1px solid rgba(42,203,53,0.3);
          color: #82dba8;
          font-size: 10.5px; font-weight: 600;
          letter-spacing: 0.14em; text-transform: uppercase;
          padding: 6px 16px; border-radius: 30px;
          margin-bottom: 28px; width: fit-content;
          font-family: 'Hind', sans-serif;
        }
        .acc-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--green); animation: vitalblink 1.6s ease infinite; }

        .acc-hero-h1 {
          font-family: 'Fraunces', Georgia, serif;
          font-size: clamp(38px, 5vw, 70px);
          font-weight: 900;
          color: #fff;
          line-height: 1.05;
          letter-spacing: -0.04em;
          margin-bottom: 26px;
        }
        .acc-hero-h1 em { font-style: italic; color: var(--green); }
        .acc-hero-h1 .gold { color: var(--gold); }

        .acc-hero-sub { font-size: 17px; line-height: 1.85; color: rgba(255,255,255,0.55); font-family: 'Lora', serif; margin-bottom: 44px; max-width: 450px; }

        .acc-hero-btns { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 48px; }
        .btn-acc-p { background: linear-gradient(135deg, var(--green), var(--mid)); color: #fff; border: none; padding: 16px 34px; border-radius: 40px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: 'Hind', sans-serif; box-shadow: 0 8px 28px rgba(42,203,53,0.4); transition: all 0.25s; letter-spacing: 0.02em; }
        .btn-acc-p:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(42,203,53,0.5); }
        .btn-acc-o { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.8); border: 1.5px solid rgba(255,255,255,0.15); padding: 16px 30px; border-radius: 40px; font-size: 14px; font-weight: 600; cursor: pointer; font-family: 'Hind', sans-serif; transition: all 0.25s; }
        .btn-acc-o:hover { background: rgba(255,255,255,0.1); }

        .acc-trust { display: flex; flex-wrap: wrap; gap: 10px; }
        .acc-trust-item { display: flex; align-items: center; gap: 7px; background: rgba(42,203,53,0.08); border: 1px solid rgba(42,203,53,0.15); border-radius: 30px; padding: 7px 14px; font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.5); }

        /* right widgets */
        .acc-widget-card { background: rgba(255,255,255,0.04); border: 1px solid rgba(42,203,53,0.15); border-radius: 20px; padding: 24px 26px; transition: all 0.25s; }
        .acc-widget-card:hover { border-color: rgba(42,203,53,0.35); background: rgba(42,203,53,0.06); }
        .acc-widget-label { font-family: 'Hind', sans-serif; font-size: 9.5px; letterSpacing: "0.18em"; text-transform: uppercase; color: rgba(255,255,255,0.25); margin-bottom: 16px; }

        /* STATS BAR */
        .acc-stats { background: linear-gradient(135deg, #0a2418 0%, #133322 100%); display: flex; justify-content: center; flex-wrap: wrap; padding: 44px 56px; border-top: 1px solid rgba(42,203,53,0.1); border-bottom: 1px solid rgba(42,203,53,0.1); }
        .acc-stat { flex: 1; min-width: 150px; text-align: center; padding: 12px 24px; position: relative; }
        .acc-stat:not(:last-child)::after { content: ''; position: absolute; right: 0; top: 20%; height: 60%; width: 1px; background: rgba(42,203,53,0.15); }
        .acc-stat-val { display: block; font-family: 'Fraunces', serif; font-size: clamp(30px,4vw,50px); font-weight: 900; color: var(--green); line-height: 1; letter-spacing: -0.03em; }
        .acc-stat-lbl { display: block; font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.4); letter-spacing: 0.14em; text-transform: uppercase; margin-top: 7px; font-family: 'Hind', sans-serif; }

        /* CONDITIONS */
        .acc-section { padding: 100px 56px; }
        .acc-section-inner { max-width: 1240px; margin: 0 auto; }
        .acc-eyebrow { font-size: 10.5px; font-weight: 700; letter-spacing: 0.22em; text-transform: uppercase; color: var(--green); margin-bottom: 10px; font-family: 'Hind', sans-serif; }
        .acc-h2 { font-family: 'Fraunces', serif; font-size: clamp(28px,3.8vw,52px); font-weight: 900; color: var(--deep); letter-spacing: -0.035em; line-height: 1.08; margin-bottom: 14px; }
        .acc-h2 em { font-style: italic; color: var(--mid); }
        .acc-desc { font-size: 16px; color: var(--muted); line-height: 1.8; font-family: 'Lora', serif; max-width: 580px; margin-bottom: 52px; }
        .acc-conditions-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }

        /* HOLISTIC */
        .acc-holistic { background: var(--forest); padding: 100px 56px; position: relative; overflow: hidden; }
        .acc-holistic-inner { max-width: 1240px; margin: 0 auto; }
        .acc-holistic-layout { display: grid; grid-template-columns: 1.1fr 1fr; gap: 80px; align-items: center; margin-top: 52px; }
        .acc-pillars { display: flex; flex-direction: column; gap: 6px; }

        /* MONITORING */
        .acc-monitoring { background: var(--sage); padding: 100px 56px; }
        .acc-monitoring-inner { max-width: 1240px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
        .acc-monitor-features { display: flex; flex-direction: column; gap: 18px; margin-top: 32px; }
        .acc-monitor-feat { display: flex; align-items: flex-start; gap: 16px; padding: 20px 22px; background: #fff; border: 1.5px solid #d0e8d8; border-radius: 16px; transition: all 0.25s; }
        .acc-monitor-feat:hover { border-color: var(--green); box-shadow: 0 6px 24px rgba(42,203,53,0.15); transform: translateX(4px); }
        .acc-monitor-feat-icon { width: 44px; height: 44px; border-radius: 12px; background: #e8f4ed; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
        .acc-monitor-feat h4 { font-family: 'Fraunces', serif; font-size: 16px; font-weight: 700; color: var(--deep); margin-bottom: 4px; }
        .acc-monitor-feat p { font-size: 13px; color: var(--muted); line-height: 1.65; font-family: 'Lora', serif; margin: 0; }

        /* TESTIMONIALS */
        .acc-testimonials { background: var(--cream); padding: 100px 56px; }
        .acc-testimonials-inner { max-width: 1240px; margin: 0 auto; }
        .acc-test-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; margin-top: 52px; }
        .acc-test-dots { display: flex; gap: 8px; justify-content: center; margin-top: 28px; }
        .acc-test-dot { width: 8px; height: 8px; border-radius: 50%; background: #c8dfd0; cursor: pointer; transition: all 0.2s; }
        .acc-test-dot.active { background: var(--green); width: 24px; border-radius: 4px; }

        /* CTA */
        .acc-cta { background: linear-gradient(145deg, var(--forest) 0%, #1a4030 100%); padding: 100px 56px; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; position: relative; overflow: hidden; }
        .acc-cta::before { content: ''; position: absolute; top: -80px; right: -80px; width: 400px; height: 400px; border-radius: 50%; background: radial-gradient(circle, rgba(42,203,53,0.12) 0%, transparent 70%); pointer-events: none; }

        .acc-cta-form { background: rgba(255,255,255,0.97); border-radius: 24px; padding: 44px; box-shadow: 0 24px 64px rgba(0,0,0,0.35); position: relative; z-index: 2; }
        .acc-form-title { font-family: 'Fraunces', serif; font-size: 24px; font-weight: 700; color: var(--deep); margin-bottom: 5px; }
        .acc-form-sub { font-size: 14px; color: var(--muted); font-family: 'Lora', serif; margin-bottom: 26px; }
        .acc-fg { margin-bottom: 14px; }
        .acc-fg label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: var(--deep); margin-bottom: 5px; font-family: 'Hind', sans-serif; }
        .acc-fg input, .acc-fg select, .acc-fg textarea { width: 100%; padding: 12px 15px; border: 1.5px solid #d0e8d8; border-radius: 10px; font-size: 14px; color: var(--deep); font-family: 'Hind', sans-serif; background: var(--cream); outline: none; transition: border-color 0.2s; }
        .acc-fg input:focus, .acc-fg select:focus, .acc-fg textarea:focus { border-color: var(--green); background: #fff; }
        .acc-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .acc-submit { width: 100%; background: linear-gradient(135deg, var(--green), var(--mid)); color: #fff; border: none; padding: 15px; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; font-family: 'Hind', sans-serif; margin-top: 8px; box-shadow: 0 6px 24px rgba(42,203,53,0.4); transition: all 0.25s; letter-spacing: 0.02em; }
        .acc-submit:hover { opacity: 0.9; transform: translateY(-1px); }

        /* FOOTER */
        .acc-footer { background: #060f0a; border-top: 1px solid rgba(42,203,53,0.08); padding: 26px 56px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
        .acc-footer p { font-size: 12px; color: rgba(255,255,255,0.25); }
        .acc-footer-kws { display: flex; gap: 8px; flex-wrap: wrap; }
        .acc-footer-kw { font-size: 10px; color: rgba(42,203,53,0.7); background: rgba(42,203,53,0.08); padding: 3px 10px; border-radius: 20px; letter-spacing: 0.03em; }

        /* RESPONSIVE */
        @media (max-width: 1100px) {
          .acc-hero { grid-template-columns: 1fr; }
          .acc-hero-right { display: none; }
          .acc-holistic-layout { grid-template-columns: 1fr; }
          .acc-monitoring-inner { grid-template-columns: 1fr; }
          .acc-cta { grid-template-columns: 1fr; gap: 48px; }
        }
          /* SERVICE CTA (page-specific) */
          .service-cta { padding: 80px 56px; font-family: 'Hind', sans-serif; }
          .service-container { max-width: 1200px; margin: 0 auto; }
          .service-btns .service-btn-primary { font-family: 'Hind', sans-serif; padding: 12px 28px; border-radius: 12px; background: linear-gradient(135deg, var(--green), var(--mid)); color: #fff; border: none; cursor: pointer; }
        @media (max-width: 900px) {
          .acc-nav { padding: 0 24px; }
          .acc-nav-links, .acc-nav-right { display: none; }
          .acc-hamburger { display: block; }
          .acc-conditions-grid { grid-template-columns: repeat(2,1fr); }
          .acc-test-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 580px) {
          .acc-hero-left { padding: 80px 24px 60px; }
          .acc-stats { padding: 32px 20px; }
          .acc-stat:not(:last-child)::after { display: none; }
          .acc-section, .acc-holistic, .acc-monitoring, .acc-testimonials, .acc-cta { padding: 60px 24px; }
          .acc-conditions-grid { grid-template-columns: 1fr; }
          .acc-form-row { grid-template-columns: 1fr; }
          .acc-footer { padding: 20px 24px; flex-direction: column; align-items: flex-start; }
        }
      `}</style>
      <BannerOne
  img={require('../assets/symptoms/cardiacCare.png')}
  title={
    <>
      Advanced Cardiac Care <br /> & <br />
      Disease Management
    </>
  }
/>

      <div className="acc-root">
       {/* <PosterOne img={aboutbanner} title={"Advanced Cardiac Care & Disease Management"} /> */}


        {/* CONDITIONS */}
        <section className="acc-section" style={{ background: "#fff" }}>
          <div className="acc-section-inner">
            <p className="acc-eyebrow">Primary Prevention of Cardiovascular Disease</p>
            <h2 className="acc-h2">Advanced Cardiac Care &<br /><em>Disease Management</em></h2>
            <p className="acc-desc">
              Our cardiologists provide advanced, continuous cardiac patient management for every major cardiovascular condition. We offer individualized, evidence-based treatment regimens to patients with heart failure, coronary artery disease, arrhythmias, hypertension, cardiomyopathy, and valve diseases. We aim at simplifying the understanding, monitoring, and management of complex heart conditions with confidence.
            </p>
            <div className="acc-conditions-grid">
              {CONDITIONS.map((c, i) => <ConditionCard key={c.title} c={c} i={i} />)}
            </div>
          </div>
        </section>

        {/* HOLISTIC CARE PLANS */}
        <section className="acc-holistic">
          <div className="acc-holistic-inner">
            <p className="acc-eyebrow" style={{ color: "var(--green)" }}>Holistic Care Plans</p>
            <h2 className="acc-h2" style={{ color: "#fff" }}>Heart Care <em style={{ color: "var(--green)" }}>For You</em> —<br />Every Dimension Covered</h2>
            <p className="acc-desc" style={{ color: "rgba(255,255,255,0.45)", marginBottom: 0 }}>
              Our cardiovascular care is based on all pillars of long-term cardiac health. We not only concentrate on medications, but also on prevention, lifestyle, monitoring, education, and continuous support. Every plan is tailored to your diagnosis, routine, goals, and risk factors to make your treatment seem clear, practical, and manageable.
            </p>
            <div className="acc-holistic-layout">
              <div className="acc-pillars">
                {PILLARS.map((p, i) => (
                  <PillarCard
                    key={p.num} p={p}
                    active={activePillar === i}
                    onClick={() => setActivePillar(i)}
                  />
                ))}
              </div>
              {/* Visual panel */}
              <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(42,203,53,0.15)", borderRadius: 24, padding: "48px 40px", display: "flex", flexDirection: "column", alignItems: "center", gap: 28 }}>
                <div style={{ fontFamily: "'Hind', sans-serif", fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.2)" }}>Your Holistic Care Map</div>
                <CarePlanCircle />
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontFamily: "'Fraunces', serif", fontSize: 22, fontWeight: 700, color: "#fff", marginBottom: 8 }}>{PILLARS[activePillar].title}</div>
                  <p style={{ fontSize: 13.5, color: "rgba(255,255,255,0.45)", fontFamily: "'Lora', serif", lineHeight: 1.75, maxWidth: 280 }}>{PILLARS[activePillar].desc}</p>
                </div>
                <div style={{ background: "rgba(42,203,53,0.1)", border: "1px solid rgba(42,203,53,0.25)", borderRadius: 12, padding: "14px 20px", width: "100%", textAlign: "center" }}>
                  <div style={{ fontSize: 10, fontFamily: "'Hind', sans-serif", letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.3)", marginBottom: 4 }}>Care Plan Phase</div>
                  <div style={{ background: "rgba(255,255,255,0.06)", borderRadius: 4, height: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${((activePillar + 1) / PILLARS.length) * 100}%`, background: "linear-gradient(90deg,var(--green),var(--light))", borderRadius: 4, transition: "width 0.4s ease" }} />
                  </div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.22)", marginTop: 6, fontFamily: "'Hind', sans-serif" }}>{activePillar + 1} of {PILLARS.length} Pillars</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        

        {/* TESTIMONIALS */}
        <section className="acc-testimonials">
          <div className="acc-testimonials-inner">
            <p className="acc-eyebrow">Patient Stories</p>
            <h2 className="acc-h2">What Our Patients Say About<br /><em>Their Cardiac Care</em></h2>
            <div className="acc-test-grid">
              {TESTIMONIALS.map((t, i) => (
                <Testimonial key={t.name} t={t} active={activeTestimonial === i} />
              ))}
            </div>
            <div className="acc-test-dots">
              {TESTIMONIALS.map((_, i) => (
                <div key={i} className={`acc-test-dot ${activeTestimonial === i ? "active" : ""}`} onClick={() => setActiveTestimonial(i)} />
              ))}
            </div>
          </div>
        </section>

        <section className="service-cta">
          <div className="service-container">
            <h2>Take Control of Your Heart Health Today</h2>
            <p> Speak with our team today about your cardiac condition and long-term management needs. We will be reviewing your diagnosis, your current medications, and where you are in your treatment journey, and build you a personalised cardiac care plan that is clear, practical, and built around your life.</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}